<template>
  <table class="table-light">
    <slot />
  </table>
</template>

<style lang="css">
@reference '@ramp106/omrjs-config-tailwind/styles/index.css';

.table-light,
.table-light th,
.table-light td {
  @apply border-t-0 border-r-0 border-b border-l-0 border-b-subtle;
}

.table-light thead th {
  @apply px-2 py-4 text-body-s-bold text-subtle;
}

.table-light tbody td {
  @apply px-2 py-2.5;
}
</style>
